/**
 * Created by lichang1 on 2019/07/18.
 */

/**
 * 解析支付回调参数函数
 * @param extraParam format "[key]:[value]~[key]:[value]"
 * @returns {{}}
 */
function parseExtraParam (extraParam) {
  let splitFlag = '~'

  if (extraParam.indexOf('@') > 0) { // 部分支付方式用@分割参数 ['易生']
    splitFlag = '@'
  }

  let extraArr = extraParam.split(splitFlag)
  let extraObj = {}
  for (let i = 0; i < extraArr.length; i++) {
    let keyValue = extraArr[i].split(':')
    extraObj[keyValue[0]] = keyValue[1]
  }

  return extraObj
}

export default {
  parseExtraParam
}
